import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {TextOnPathModeEntry, TextOnPathModeHistory} from '@PosterWhiteboard/poster/poster-text-on-path/poster-text-on-path.types';

/** Mirror of PosterTextOnPath for the Text on path panel; the domain class owns the values. */
export interface TextOnPathModeState extends TextOnPathModeEntry {
  isActive: boolean;
}

const initialState: TextOnPathModeState = {
  isActive: false,
  pageHashedId: '',
  isRedrawingText: false,
  canUndo: false,
  canRedo: false,
};

const textOnPathMode = createSlice({
  name: 'textOnPathMode',
  initialState,
  reducers: {
    enterTextOnPathMode: (_state: TextOnPathModeState, action: PayloadAction<TextOnPathModeEntry>) => {
      return {...action.payload, isActive: true};
    },
    updateTextOnPathMode: (state: TextOnPathModeState, action: PayloadAction<TextOnPathModeHistory>) => {
      return {...state, ...action.payload};
    },
    exitTextOnPathMode: () => {
      return initialState;
    },
  },
});

export const {enterTextOnPathMode, updateTextOnPathMode, exitTextOnPathMode} = textOnPathMode.actions;
export const textOnPathModeReducer = textOnPathMode.reducer;
